import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Container, Form, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';

const ContactForm = () => {
    const { t } = useTranslation();
    const [formData, setFormData] = useState({
        name: '',
        phone: '',
        email: '',
        message: ''
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        // Here you would typically handle the form submission,
        // e.g., send the data to an API endpoint.
        alert(`Form submitted!\nName: ${formData.name}\nEmail: ${formData.email}`);
        // Reset form after submission
        setFormData({ name: '', phone: '', email: '', message: '' });
    };

    return (
        <section className="float-left w-100 position-relative contact-form-con padding-top padding-bottom main-box">
            <Container className="wow animate__animated animate__fadeInUp">
                <div className="heading-title-con text-center">
                    <span className="special-text color-blue d-block wow animate__animated animate__fadeInLeft">{t('contact_form_tag')}</span>
                    <h2 className="wow animate__animated animate__fadeInRight" dangerouslySetInnerHTML={{ __html: t('contact_form_title') }}></h2>
                </div>
                <div className="row wow animate__animated animate__fadeInDown">
                    <div className="col-xl-12 col-lg-12 mr-auto ml-auto">
                        <Form className="main-form text-center" onSubmit={handleSubmit}>
                            <ul className="list-unstyled p-0 float-left w-100 mb-0">
                                <li><Form.Control type="text" name="name" placeholder={t('contact_form_name')} value={formData.name} onChange={handleChange} required /></li>
                                <li><Form.Control type="tel" name="phone" placeholder={t('contact_form_phone')} value={formData.phone} onChange={handleChange} /></li>
                                <li><Form.Control type="email" name="email" placeholder={t('contact_form_email')} value={formData.email} onChange={handleChange} required /></li>
                                <li><Form.Control as="textarea" name="message" placeholder={t('contact_form_message')} rows={6} value={formData.message} onChange={handleChange} required /></li>
                            </ul>
                            <div className="d-inline-block">
                                <Button type="submit" className="primary_btn">
                                    {t('contact_form_send_btn')} <FontAwesomeIcon icon={faArrowRight} className="ms-2" />
                                </Button>
                            </div>
                        </Form>
                    </div>
                </div>
            </Container>
        </section>
    );
};

export default ContactForm;